const consola = require('consola'); consola.level = process.env.CONSOLA_LEVEL;
// import { mapGetters, mapMutations, mapActions } from 'vuex'
// import config from '~/../config/nuxt'
import detectWebp from '~/src/utils/detect-webp'
import { isChrome, isChromeIOS, isTrident, isEdge, isSafari, isFirefox, isYandex } from '~/plugins/browser-detect'
import HelveticaRegular from '~/assets/fonts/helvetica-now-display-regular.woff2'
import HelveticaMedium from '~/assets/fonts/helvetica-now-display-medium.woff2'
import HelveticaLight from '~/assets/fonts/helvetica-now-display-light.woff2'
import Waldorf from '~/assets/fonts/Waldorf-Pro-Regular.otf'
import endsWith from 'ends-with'

import { setOptions, bootstrap } from 'vue-gtag'

let supportsWebP = false;

if (process.browser)
{
	detectWebp()
		.then( canDecodeWebp => supportsWebP = canDecodeWebp )
}

// NOTE: This mixin is included in the pages themselves, not the layout


export default {
	head()
	{
		// consola.debug('header-meta: head()', this.pageData)
		consola.debug('header-meta: head() host ', this.$store.getters.originUrl)
		let userMeta = [];

		// this.pageData.site.meta
		if (this.pageData && this.pageData.site && this.pageData.site.meta)
		{
			for (let i = 0; i < this.pageData.site.meta.length; i++)
			{
				const pair = this.pageData.site.meta[i];
				userMeta.push( {
					hid: pair[0],
					name: pair[0],
					property: pair[0],
					content: pair[1]
				} )
			}
		}

		if (this.pageData && this.pageData.meta_pairs)
		{
			for (let i = 0; i < this.pageData.meta_pairs.length; i++)
			{
				const pair = this.pageData.meta_pairs[i];
				userMeta.push( {
					hid: pair[0],
					name: pair[0],
					property: pair[0],
					content: pair[1]
				} )
			}
		}

		const isAcademy = this.$store.getters.originUrl.indexOf('academy.') > -1;

		// consola.debug('head() $route.path: ', this.$route.path);
		// consola.debug('head() process: ', process);
		// consola.debug('head() $route: ', this.$route);
		// consola.debug('head() browserBaseUrl: ', this.$store.getters.browserBaserUrl);
		// consola.debug('head() env: ', this.env);
		// consola.debug('head() $env: ', this.$env);
		// consola.debug('head() process.env: ', process.env);
		// consola.debug('head() config.env: ', config.env);
		// consola.debug('head() process.env: ', process.env.APP_URL);
		// consola.debug('head() allLanguages: ', this.$store.getters.allLanguages);
		let routeParts = this.$route.path.split('/').filter(x => x.length > 0);
		if (!isAcademy)
			routeParts.shift();
		const url = '/' + routeParts.join('/');
		let hreflangLinks = [{
			rel: "alternate",
			hreflang: "x-default",
			href: isAcademy ? `${this.$store.getters.originUrl}${url}` : `${this.$store.getters.originUrl}/el${url}`
		}];
		// this.$route.path

		// create <meta rel="alternate"> only for corporate
		if ( !isAcademy )
		{
			// debugger
			for (let i = 0; i < this.$store.getters.allLanguages.length; i++)
			{
				const lang = this.$store.getters.allLanguages[i];
				if (!lang.is_active)	continue;

				hreflangLinks.push({
					rel: "alternate",
					hreflang: lang.lang_code,
					href: `${this.$store.getters.originUrl}/${lang.lang_code}${url}`
				})
			}
		}

		let preloadLinks = [
			{
				rel: 'preload',
				href: HelveticaRegular,
				as: 'font',
				crossorigin: "anonymous", // important, otherwise it will re-fetch
			},
			{
				rel: 'preload',
				href: HelveticaMedium,
				as: 'font',
				crossorigin: "anonymous", // important, otherwise it will re-fetch
			},
			{
				rel: 'preload',
				href: HelveticaLight,
				as: 'font',
				crossorigin: "anonymous", // important, otherwise it will re-fetch
			},
			{
				rel: 'preload',
				href: Waldorf,
				as: 'font',
				crossorigin: "anonymous", // important, otherwise it will re-fetch
			},
		];


		let jsonld = [];
		// if (process.server)
		{
			if (this.pageData && this.pageData.jsonld)
				for (let item of this.pageData.jsonld)
				{
					if (item.type)
					{
						let data = item.data;
						if (typeof data == 'string')
							data = JSON.parse(data);
						item.data = data;
						data["@context"] = "http://schema.org";
						data["@type"] = item.type;

						//===========
						// Fix for hardcoded old Organisation urls
						if (item.type == 'Course' && data.provider)
						{
							if (data.provider['@type'] == 'EducationalOrganization')
							{
								data.provider["url"] = {"@id": "https://academy.el-translations.com"};
							}

							if (!data.description || data.description=='null')
							{
								let descr = this.pageData.description;
								if (!descr || descr=='null')
								{
									const head = this.pageData.block_list && this.pageData.block_list.find(x => x.block_type=="head" ) || null;
									if (head)
										descr = head.subtext;
								}
								if (descr && descr!='null')
									data.description = descr;
							}
						}
						//===========

						jsonld.push(
							{
								// innerHTML: JSON.stringify(data),
								json: (data),
								type: 'application/ld+json'
							}
						)
					}
					else
					{

					}
				}

		}

		let browserDetection = [];//{};
		// if (process.browser)
		// {
		// 	if (isChrome()) browserDetection.push('browser-chrome');
		// 	if (isChromeIOS()) browserDetection.push('browser-chrome-ios');
		// 	if (isTrident()) browserDetection.push('browser-trident');
		// 	if (isEdge()) browserDetection.push('browser-edge');
		// 	if (isSafari()) browserDetection.push('browser-safari');
		// 	if (isYandex()) browserDetection.push('browser-yandex');

		// 	document.documentElement.class += ' '+browserDetection.join(' ');
		// 	// browserDetection =
		// 	// {
		// 	// 	'browser-chrome': isChrome(),
		// 	// 	'browser-chrome-ios': isChromeIOS(),
		// 	// 	'browser-trident': isTrident(),
		// 	// 	'browser-edge': isEdge(),
		// 	// 	'browser-safari': isSafari(),
		// 	// 	'browser-yandex':  isYandex(),
		// 	// };
		// }

		// consola.debug('route: ', this.$route)
		// consola.debug('pageData: ', this.pageData)
		// consola.debug('header-meta: lang ', this.$store.getters.lang);

		return {
			title: this.pageData ? this.pageData.title : '',
			meta: [
				// { hid: 'site_name', name: 'site_name', content: 'header-meta mixin' },
				{ hid: 'robots', name: 'robots', property: 'robots', content: endsWith(this.$route.path, "/edit") ? 'none' : 'index, follow' },
				{ hid: 'og:type', name: 'og:type', property: 'og:type', content: 'website' },
				// { hid: 'og:site_name', name: 'og:site_name', property: 'og:site_name', content: this.pageData && this.pageData.site ? this.pageData.site.name : '' },
				{ hid: 'og:site_name', name: 'og:site_name', property: 'og:site_name', content: 'el-translations' },
				{ hid: 'og:title', name: 'og:title', property: 'og:title', content: this.pageData ? this.pageData.title : '' },
				{ hid: 'description', name: 'description', property: 'description', content: this.pageData ? this.pageData.description : '' },
				{ hid: 'og:description', name: 'og:description', property: 'og:description', content: this.pageData ? this.pageData.description : '' },
				{ hid: 'og:image', name: 'og:image', property: 'og:image', content: this.$store.getters.originUrl + (this.pageData ? this.pageData.thumbnail : '') },
				{ hid: 'og:image:width', name: 'og:image:width', property: 'og:image:width', content: '1200' },
				{ hid: 'og:image:height', name: 'og:image:height', property: 'og:image:height', content: '630' },
				{ hid: 'og:url', name: 'og:url', property: 'og:url', content: this.$store.getters.originUrl + this.$route.path },
				{
					// this.pageData.meta_pairs
				// name: 'viewport',
				// content: 'width=device-width,initial-scale=1.0,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no'
				},
				...userMeta
			],
			link:
			[
				...preloadLinks,
				...hreflangLinks,
			],
			htmlAttrs:
			{
				lang: this.$store.getters.lang,
				// class: [
				// 	isTrident() ? 'browser-trident': '',
				// 	isEdge() ? 'browser-edge': '',
				// 	isSafari() ? 'browser-safari': 'not-safari', //,
				// ]
			},
			__dangerouslyDisableSanitizers: ['script'],
			script: [
				// {
				// 	innerHTML: JSON.stringify(this.structuredData),
				// 	type: 'application/ld+json'
				// },
				...jsonld
			],
			bodyAttrs: {
				// class: {
				// 	'show-modal': this.showModal && this.showModal > 0,
				// 	...browserDetection
				// }
				class: [
					// this.showMobileMenu ? 'show-mobile-menu' : '',
					this.showModal && this.showModal > 0 ? 'show-modal' : '',
					// supportsWebP ? 'webp' : '',
					// this.topBanner ? 'has-topbanner' : '',
					// isChrome() ? 'browser-chrome': 'not-chrome',
					// isChromeIOS() ? 'browser-chrome-ios': 'not-chrome-ios',
					// isTrident() ? 'browser-trident': 'not-trident',
					// isEdge() ? 'browser-edge': 'not-edge',
					// isSafari() ? 'browser-safari': 'not-safari', //,
					// isYandex() ? 'browser-yandex': 'not-yandex', //,
					// ...browserDetection
					...(this.bodyClasses || [])
				]
			}
		}
	},


	beforeCreate()
	{
		consola.debug('header-meta: beforeCreate');
		// consola.debug('header-meta: clearSeoPageEntries');
		// this.$store.commit('clearSeoPageEntries');

		//* INIT GTag Analytics && FB PIXEL,
		//* these are retrieved from the store nuxtServerInit,
		//* no need to 'dispatch'
		// this.$store.dispatch('fetchAnalytics').then( () =>
		{
			const id = this.$store.getters.ga_id || this.$store.getters.gtag_id;
			// console.log('google analytics: ',id )
			setOptions({
				config: { id, params: { send_page_view: true } }
			})

			bootstrap()
			// .then( ( gtag ) =>
			// {
			// 	// all done!
			// })
			consola.debug('Google Analytics enabled ', id)

			if (this.$fb)
			{
				this.$fb.setPixelId(this.$store.getters.fb_pixel_id);
				this.$fb.enable();
				consola.debug('FB Pixel enabled ', this.$store.getters.fb_pixel_id)
			}
		}
		// );
	},

	created()
	{
		consola.debug('header-meta: created');
		// const isAcademy = this.$store.getters.browserBaserUrl.indexOf('academy.') > -1;
		// consola.debug('header-meta: host ', this.$store.getters.browserBaserUrl)
		// consola.debug('header-meta: isAcademy ', isAcademy)
	},


	mounted()
	{
		consola.debug('header-meta: mounted');
		if (typeof window !== 'undefined')
		{
			this.$store.dispatch('setDeviceWidthFromWindow');
		}
	}
}
